import { type AnyActorRef } from "xstate";

import { type StoredPage } from "./types/editors.types";

const EMPTY_STORED_PAGE: StoredPage = {
	doc: {
		type: "doc",
		content: [],
	},
	metadata: {
		id: "",
		slug: "",
		title: "",
		archived: false,
		parentPageID: null,
		type: "markdown",
	},
};

export const useDocumentActor = (documentId: string) => {
	return undefined as unknown as AnyActorRef;
};

export const useDocumentMetadata = (documentId: string) => {
	return undefined;
};

export const usePageData = (documentId: string, pageId: string) => {
	return EMPTY_STORED_PAGE;
};
